<template>
  <div class="container">

    <div class="content-center">
      <div class="content-map" id="mapContent">
          <div id="mapBox" class="map-back" ref="mapBox">
              <div class="echart-map" ref="chinaEchart">
              </div>
          </div>
          <!-- 1.耗材月销量 -->
          <div class="bottom-line">
            <p class="part-title">
              <span style="float: left;margin-right: 5px;font-size: 18px;font-weight: bold;color: #FEFEFE;">耗材月销量</span>
                <el-date-picker
                  id="consMonthValue"
                  v-model="consMonthValue"
                  size="mini"
                  type="year"
                  style="width: 120px;"
                  format="yyyy 年"
                  :editable="false"
                  :clearable="false"

                  @change="changeConsMonthYear"
                  >
                </el-date-picker>
            </p>
            <div  class="bottom-line-chart" id="consMonthSalesChart" ref="consMonthSalesChart"></div>
          </div>
          <!-- 2.耗材年销量 -->
          <div class="bottom-line">
            <p class="part-title">
              <span style="float: left;margin-right: 5px;font-size: 18px;font-weight: bold;color: #FEFEFE;">耗材年销量</span>
                <el-date-picker
                  id="consYearStart"
                  v-model="consYearStart"
                  size="mini"
                  type="year"
                  style="width: 120px;"
                  format="yyyy 年"
                  :editable="false"
                  :clearable="false"

                  @change="changeStartYearOfCons"
                  >
                </el-date-picker>
                ～
                <el-date-picker
                  id="consYearEnd"
                  v-model="consYearEnd"
                  size="mini"
                  type="year"
                  style="width: 120px;"
                  format="yyyy 年"
                  :editable="false"
                  :clearable="false"

                  @change="changeEndYearOfCons"
                  >
                </el-date-picker>
            </p>
            <div  class="bottom-line-chart" id="consYearSalesChart" ref="consYearSalesChart"></div>
          </div>
          <!-- 3.设备年销量 -->
          <div class="bottom-line">
            <p class="part-title">
              <span style="float: left;margin-right: 5px;font-size: 18px;font-weight: bold;color: #FEFEFE;">设备总销量</span>
                <el-date-picker
                  id="equipYearStart"
                  v-model="equipYearStart"
                  size="mini"
                  type="year"
                  style="width: 120px;"
                  format="yyyy 年"
                  :editable="false"
                  :clearable="false"

                  @change="changeStartYearOfEquip"
                  >
                </el-date-picker>
                ～
                <el-date-picker
                  id="equipYearEnd"
                  v-model="equipYearEnd"
                  size="mini"
                  type="year"
                  style="width: 120px;"
                  format="yyyy 年"
                  :editable="false"
                  :clearable="false"

                  @change="changeEndYearOfEquip"
                  >
                </el-date-picker>
            </p>
            <div  class="bottom-line-chart" id="equipYearSalesChart" ref="equipYearSalesChart"></div>
          </div>
      </div>
    </div>

    <div class="content-right">
      <!-- 1。耗材数据分析 -->
      <div class="data-cons">
        <!-- 1.1 耗材销量Top10 -->
        <div class="table-hospital-cons">
          <p class="part-title">
            <span style="float: left;margin-right: 5px;">耗材消耗Top10</span>
                <el-date-picker
                  id="topValue"
                  v-model="topValue"
                  size="mini"
                  type="year"
                  style="width: 120px;"
                  format="yyyy 年"
                  :editable="false"
                  :clearable="false"

                  @change="changeConsTopYear"
                  >
                </el-date-picker>
          </p>
          <div class="table-hospital-cons-chart" id="tableConsSales" ref="tableConsSales">
          </div>
        </div>
        <div class="data-cons-analysis">
          <!-- 1.2耗材类型 -->
          <div class="cons-type">
            <p class="part-title">耗材类型占比</p>
            <div class="cons-type-chart" id="consTypeChart" ref="consTypeChart"></div>
          </div>
          <div class="cons-sales" >
            <p class="part-title">耗材总消耗</p>
            <div class="cons-sales-chart" id="consSalesumChart" ref="consSalesumChart"></div>
          </div>
          <!-- 1.3 手术部位 -->
          <!-- <div class="surgery-part" >
            <p class="part-title">手术部位统计</p>
            <div class="surgery-part-chart" id="surgeryPart" ref="surgeryPart"></div>
          </div> -->
        </div>

      </div>
      <!-- 2.设备数据分析 -->
      <div class="data-equip">
        <!-- 2.1设备分布 -->
        <div class="table-equip-sales">
          <p class="part-title">设备分布</p>
          <div class="table-equip-sales-chart">
            <el-table
              v-loading='loading'
              :data="mapDistributionData"
              :cell-style="tableCellStyle"
              :header-cell-style="tableHeaderCellStyle"
              height="630"
              style="border: 0px;"
              >
              <el-table-column
                prop="provinceName"
                label="地区">
              </el-table-column>
              <el-table-column
                prop="hospitalAmount"
                label="单位"
                >
              </el-table-column>
              <el-table-column
                prop="equipmentAmount"
                label="设备"
                >
              </el-table-column>
              <el-table-column
                prop="consumableUsedAmount"
                label="耗材"
                >
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="data-equip-analysis">
          <div class="equip-status">
            <p class="part-title">设备状态统计</p>
            <div class="equip-status-chart">
              <div class="part-one" style="border-right: 1px #1A3F81 solid;border-bottom: 1px #1A3F81 solid;">
                <img src="../../assets/image/home/index_equip.png" alt="" srcset="">
                <p class="part-one-title">手术中</p>
                <p class="part-one-detail">{{equipSurgeryAmount}}</p>
              </div>
              <div class="part-one" style="border-bottom: 1px #1A3F81 solid;">
                <img src="../../assets/image/home/index_equip_online.png" alt="" srcset="">
                <p class="part-one-title">正常</p>
                <p class="part-one-detail">{{equipOnAmount}}</p>
              </div>
              <div class="part-one" style="border-right: 1px #1A3F81 solid;padding-top: 30px;">
                <img src="../../assets/image/home/index_equip_maintain.png" alt="" srcset="">
                <p class="part-one-title">故障</p>
                <p class="part-one-detail">{{equipFaultedAmount}}</p>
              </div>
              <div class="part-one" style="padding-top: 30px;">
                <img src="../../assets/image/home/index_equip_close.png" alt="" srcset="">
                <p class="part-one-title">关机</p>
                <p class="part-one-detail">{{equipOffAmount}}</p>
              </div>
            </div>
          </div>
          <div class="surgery-part" >
            <p class="part-title">手术部位统计</p>
            <div class="surgery-part-chart" id="surgeryPart" ref="surgeryPart"></div>
          </div>
        </div>



      </div>
    </div>
  </div>

</template>

<script>
// import  'echarts/map/js/china'
// import * as echarts from 'echarts';
import { forEach, split } from 'lodash';
import {areaConversionUtil} from '../../utils/povince_handle.js'

  export default {
    data() {
      return {

        // 设备状态的统计
        equipOnAmount:0,
        equipOffAmount:0,
        equipFaultedAmount:0,
        equipSurgeryAmount:0,
        equipStatusData:[], //设备状态统计

        // 耗材月销量
        consMonthData:{
          year:[],
          month:[],
          value:[]
        },

        //耗材年销量
        consYearData:{
          year:[],
          value:[]
        },

        // 设备年销量
        equipYearData:{
          year:[],
          value:[],
        },


        partData:[],//手术部位统计
        consTypeData:[],//耗材类型
        hospitalData:[],//医院耗材消耗
        mapDistributionData:[],//地图上各省份设备统计

        baseYearValue:new Date(),
        loading:false,
        topValue:new Date(),//耗材Top年份
        consMonthValue:new Date(), //耗材月销量参数
        consYearStart:new Date((new Date().getFullYear()-4) +'-01-01'),//耗材年销量开始年份
        consYearEnd:new Date(),//耗材年销量结束年份
        equipYearStart:new Date((new Date().getFullYear()-4) +'-01-01'),//设备年销量开始年份
        equipYearEnd:new Date(),//设备年销量结束年份

        myMapChart:null, //地图
        myChart12:null, //左2 耗材月销量
        months:["1月", "2月", "3月", "4月", "5月", "6月",'7月','8月','9月','10月','11月','12月'],
        myChart13:null,//左3 耗材年销量
        myChart14:null,//左4 设备年销量

        myChart21:null, //中1 耗材消耗Top10
        // myChart22:null, //中2 设备分布
        colors21:['#FF5000','#FAAA39','#6FCF6A','#fff'],

        myChart31:null, //右1 耗材类型占比
        myChart32:null, //右2 耗材总消耗
        // myChart33:null, //右3 设备状态
        myChart34:null, //右4 手术部位统计
      }
    },
    beforeDestroy() {
      if(this.myMapChart){
        this.myMapChart.dispose();
        this.myMapChart = null;
      }

      if(this.myChart12){
        this.myChart12.dispose();
        this.myChart12 = null;
      }

      if(this.myChart13){
        this.myChart13.dispose();
        this.myChart13 = null;
      }

      if(this.myChart14){
        this.myChart14.dispose();
        this.myChart14 = null;
      }

      if(this.myChart21){
        this.myChart21.dispose();
        this.myChart21 = null;
      }

      if(this.myChart31){
        this.myChart31.dispose();
        this.myChart31 = null;
      }

      if(this.myChart32){
        this.myChart32.dispose();
        this.myChart32 = null;
      }

      if(this.myChart34){
        this.myChart34.dispose();
        this.myChart34 = null;
      }

      window.removeEventListener('resize',this.mapBoxResize);
      window.removeEventListener('resize',this.sizeFunOfMapChart);
      window.removeEventListener('resize',this.sizeFunOfMyChart12);
      window.removeEventListener('resize',this.sizeFunOfMyChart13);
      window.removeEventListener('resize',this.sizeFunOfMyChart14);
      window.removeEventListener('resize',this.sizeFunOfMyChart21);
      window.removeEventListener('resize',this.sizeFunOfMyChart31);
      window.removeEventListener('resize',this.sizeFunOfMyChart32);
      window.removeEventListener('resize',this.sizeFunOfMyChart34);

    },
    created() {

    },
    mounted() {

      window.addEventListener('resize',this.mapBoxResize)

      this.mapBoxResize();


      // // 布局
      this.setMap()
      this.setConsMonthChart();//耗材月销量
      this.setConsYearChart();//耗材年销量
      this.setEquipYearChart();//设备年销量
      this.setConsSumChart();//近10个月耗材总销量
      this.setHospitalConsChart()//医院耗材消耗排名
      this.setConsTypeChart();//耗材类型
      this.setSurgeryPartChart();//手术部位



      // 获取数据
      this.getConsMonthDistribution()
      this.getConsYearDistribution();
      this.getEquipSumDistribution();//设备总销量
      this.getConsSumDistribution();//耗材总销量
      this.getEquipStatus();//设备状态
      this.getSurgeryPartDistribution();//手术部位
      this.getConsTypeDistribution()//耗材类型
      this.getHospitalDistribution()//医院耗材消耗排名
      this.getDistribution();//各省设备医院分布

        if(sessionStorage.getItem('loaded') === null){
          sessionStorage.setItem('loaded',true)
          window.location.reload()
        }
    },
    methods:{
      tableCellStyle() {
        return 'border-color: transparent;color: #fff;text-align:center;'
      },
      tableHeaderCellStyle() {
        return 'border-color: transparent;color:lightgray;text-align:center;background-color:transparent;'
      },
      sizeFunOfMapChart(){
        if(this.myMapChart){
          this.myMapChart.resize()
        }
      },
      sizeFunOfMyChart12(){
        if(this.myChart12){
          this.myChart12.resize()
        }
      },
      sizeFunOfMyChart13(){
        if(this.myChart13){
          this.myChart13.resize()
        }
      },
      sizeFunOfMyChart14(){
        if(this.myChart14){
          this.myChart14.resize()
        }
      },
      sizeFunOfMyChart21(){
        if(this.myChart21){
          this.myChart21.resize()
        }
      },
      sizeFunOfMyChart31(){
        if(this.myChart31){
          this.myChart31.resize()
        }
      },
      sizeFunOfMyChart32(){
        if(this.myChart32){
          this.myChart32.resize()
        }
      },
      sizeFunOfMyChart34(){
        if(this.myChart34){
           this.myChart34.resize()
        }

      },
      mapBoxResize(){

        //地图
        var element1 = this.$refs.mapBox;
        if(element1){
          let style1 = window.getComputedStyle(element1);
          // window.getComputedStyle(element1,null);
          const height = style1.height;
          const width = style1.width;

          var element2 = this.$refs.chinaEchart;
          element2.style.width = width;
          element2.style.height = height;
        }

      },
      isNull(value){
        if(value){
          return false;
        }
        return true;
      },
      setMap(){
        var myEchart = this.$refs.chinaEchart;
        this.myMapChart = echarts.getInstanceByDom(myEchart);
        if(this.myMapChart === undefined){
          this.myMapChart = echarts.init(myEchart);
        }else{
          this.myMapChart.dispose()
          this.myMapChart = null;
          this.myMapChart = echarts.init(myEchart);
        }


        var max = 6000,
          min = 10;
        var maxSize4Pin = 100,
          minSize4Pin = 20;

        var option = {
          tooltip: {
            show: true,
            formatter: function (params) {
              if(params.value.length > 1){
                return (

                  params.name +
                  "</br>" +
                  '设备：' +
                  params.value[2]
                  // "</br>" +
                  // "耗材消耗:" +
                  // params.data.consAmount +
                  // "</br>" +
                  // "单位:" +
                  // params.data.hospitalAmount +
                  // "</br>" +''
                );
              }else{
                return (

                  params.name +
                  "</br>" +
                  '设备：' +
                  0
                );
              }
            },
          },

          geo: {
            map: "china",
            show: true,
            roam: false,
            label: {
              emphasis: {
                show: false,
              },
            },
            layoutSize: "100%",
            itemStyle: {
              normal: {
                borderColor: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#00F6FF",
                    },
                    {
                      offset: 1,
                      color: "#53D9FF",
                    },
                  ],
                  false
                ),
                borderWidth: 3,
                shadowColor: "rgba(10,76,139,1)",
                shadowOffsetY: 0,
                shadowBlur: 60,
              },
            },
          },
          series: [
            {
              type: "map",
              map: "china",
              aspectScale: 0.75,
              //zoom:1.1,
              label: {
                normal: {
                  show: false,
                },
                emphasis: {
                  show: false,
                },
              },
              itemStyle: {
                normal: {
                  areaColor: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#073684", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#061E3D", // 100% 处的颜色
                      },
                    ],
                  },
                  borderColor: "#215495",
                  borderWidth: 1,
                },
                emphasis: {
                  areaColor: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#073684", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#061E3D", // 100% 处的颜色
                      },
                    ],
                  },
                },
              },
              data: [],//outdata,
            },
            {
              type: "scatter",
              coordinateSystem: "geo",
              rippleEffect: {
                brushType: "stroke",
              },
              showEffectOn: "render",
              itemStyle: {
                normal: {
                  color: {
                    type: "radial",
                    x: 0.5,
                    y: 0.5,
                    r: 0.5,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(5,80,151,0.2)",
                      },
                      {
                        offset: 0.8,
                        color: "rgba(5,80,151,0.8)",
                      },
                      {
                        offset: 1,
                        color: "rgba(0,108,255,0.7)",
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                },
              },
              label: {
                normal: {
                  show: true,
                  color: "#fff",
                  fontWeight: "bold",
                  position: "inside",
                  formatter: function (para) {
                    return "{cnNum|" + para.data.value[2] + "}";
                  },
                  rich: {
                    cnNum: {
                      fontSize: 13,
                      // color: "#D4EEFF",
                      color:"transparent",
                    },
                  },
                },
              },
              symbolSize: function (rawValue, params) {
                return 40;
              },
              symbol:'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAIRlWElmTU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAIdpAAQAAAABAAAAWgAAAAAAAABIAAAAAQAAAEgAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAADKgAwAEAAAAAQAAADIAAAAAhvHCqAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDYuMC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KGV7hBwAAC79JREFUaAXtWmlsXNUV/u5782bGjp3YGCeQhKwODrFJSBxMFkRYyhYlQItCW9QitkJTiYIKohFVRVBpVfqjm9RNILqAaIsVtUVASwNpqEgbbNykAZskZLUJSbxvY8/6br9z5z1nMhnbYxAQVbnK9XvvLuec75xzz733TBSyigYsBbj1TtVFUOrbKY1Xlyfe+QXbFdu1PDlFKurMc51HgV8s/OIQaBlrGj6tP+RuCe/6UPUbR0JL9K7gQt3gVNVK20HMCntA5HPEImPeQo0jNZ/xIxIaR0cgx1jyNqoPHUUcASrftVS5tM3Goag8/4HLA5OKekuHEomJQdedqKECccvuC9uJPgwWdig0JmCqMYsBtdT7lvnjKWlFrLMaccAijSTnGvmyaeQC4o3RqSBsJDlPa13c4CxY7CrrZnYu1OiYl4hjMicXQVlBm2AD2k2lklYEweixelTvIbhtynFfUZGmnT4osVA/inU7yilM2hVPCLRO3BJb0W7cVtpfx1aXHy7HpvgpVVAYF5f3zDI8yW/0B24PVr9ZBKs2Apda0IMOrIkT6HVCTcBJdU1Nq0j80SYLsWCAgxQXVx9Hc1Ftoyw/Wobdm3we43kSfCGcxPyUlSofjJW/dgW2Jn0ZM+mMYpETNgwQRIJC9yBFlxkuogTRjlS4NFwq7iIRIL6SIFAYkPYAlbGSI1a+majZha7Yi4jGGzSsVjvsdPuUXCitXbcYli6zXDWZE2fQDOez/3xXRyvI4txyOKo91PFLxLCetrQIRqzFR7qMCsQfRO37Exy/zTyFUoJdRXSu0jAUnUx3DNq6Yx859Msk3ee5RCFdssBeuDBZUY4hN4VkTzSuejg5oGhDOiIQCrk2HL7ZHpMkKcTZxxqPaJfawXLpuoU0N6aDki8XPSG/Qj5ZRVpiKaiKEvoaBTtUL85MIYoQumENAjOne3N0QFkWkm2dye7f/8tN7Ntm0w3tYMlFQVVZCr23hwqneil9VFP/FFLRaz0J2aPZo5QJpUAkS4rhz1GBeJIMDz7pJUaHmH8Wkru3GftOfOBhlN+wGsUXVCJYUoJAKGSGi0CiczeZCMR/2odIS4vu2LzF7drwkNbE4MxbAf3BAFEkaQrZwhg3PEbyYWxFcNJG7/WN5Y048RgVyIlh3ptQFrU7FG1OKeIEUbz+fpy3/m6UXFgtij2l+G2W4yB8dplUVbZksRr4wjoc+UMdOjY8hODUGugiitIeM7SNZkjJB+QTJdfsJr8rb9dKTxCD85+aWmxATPn5rzD3K3dyF6EQTbvpD9Rf9QVpQGaFZPDlCtZS2S56L5o5A5XffBBFC6txePV1jAoXAqVcgl1xIEhHypgqzH2FDEue9eK5XlbrSJ8CYmYxEvv+jWnPPIeK9fcYEMJTt3fAunAB1F/+CnSL35M114ZfBQT6+mH1D8ClozBKcZLGtOuvRcUb25AaeDs9ZxLBGEcaSYjc7fm7FomreSVI0J1KH/seZn3pi4aiTibTFgmn1wRuugmYexVw72qgci61XAK3lwD2HwQWVaF3/nwo20HIsREKOgbQ5JUrEN30J7Te/FkEL7gU+gAVkWWR3OKfaM0PiNi1hEx3dzMqTcXMu283FHSKUUu0LsWPM6s+xy2ZQj/8IJdT3LiEhWVIvPoEWuZUmPA6IZ5AinOTjHaFYYmqwLQ1q9H1+dsR/eNvYE9fCt1mTkOmL58/+bkW91I1KcTdvBmlP9yAwqnnGk0qO0cQaesHFpQjNetKngPmQj3xE7TseBrbp56HwcgQFC3YTQsdO0ZXpBJEES4B2cEgJt9xa/ocUkBw3FzHXBgZCMcGItYQnw1ws+PrpJqL0tNlMecoujgEt7mFgqUQffpxbK5dgYbOAajuXrjcCJvfa0FbexfmzZmOAlpDyCgTdYHiyvPTR+8Io5fXloNFzqY8XEuQkBtdR94CxcU5CQkssyHu74K6bhGab7weLxeUoaytG1MmFaGfnrJ91y6sumQBLl4839BwSdOiwL5OAoWFBDITupuRizv+eEoeQLLI5TCENAlbcbT+G2vx3OxKvHw8hit4QNE8au5tbcN7h9rw0D1rMHsG3dKTXECcVEw7qWU1nzRmhI/8gZC4CCxRKrsIXxGuAWvxtdA0NB7uxR1nFaD5WAof7DiMqlll+MEjX8aEwjAXuQtbDik5Cm8C5NEBFS5lqCYfO39EeQARDZ0gGDl4EGfXLqUY6TZxJxHrP4ECXEK3wLE+1NI0v+4eBHZ14amNV+OuW68zYo8IwrPQ4AdH6Z6DsEsLoLt43BwHkNyqMWy9P2IGh8MiceM6XZteRCrOsCpa9QSQkREDLIkrC23Ut/Ls1NSN13972zAIlxtgTksIDS+Ed255Pc1U2mSNCO88y9hAPEK6Kwa7ciUG636Ho39/zbSa3dnrN4F4ehhb9vdi/rQi7H3pAVy2fJE5tphjiSdstly8V9LgCt3N76Lz4W/AmcY9pJORYRzWEJp5AwH3Et01SONU4f21q9FDxrKPaPq8ISSCvt+K+66pwBtPfd2E1xStYFFIEfSUQq27XG8Wz2nRzi4cuG8DheG4AOkMyKX0lBmjNuQPRDTE06mawgsUZmM3s0Xd7zTBdtLLLNIfwYbvrsWPH70LZaUT04s6lxUIQE4Esu4ExNDxNjTf9lXEt7wAu2IZ9GFuqOMMvYIwj8XuKUI0FLagjw7BmnE2dIuD3Ty6z3j5bzz4XYPalUtw1ZW1ZqWkRNMEkel6hopnHf9E0LljJ/Zfeyfc9h0IVPJesoe33zCdNG1kj3F+j/wtIvSEQYgCtvCidk4R7JJF5gi+87Z7EavfjkRvr+FqU9Ny9DilEkhyaAgdbzWi+ZFHsWfJYp6a22HPvuQjgRCm+VvEiMg/nmVwLApVFuQNbzlizzyp9zzzJIIzalF8541K7hihKUyFcSwdiV5kGZAR3ln6X9mK6Kt/NovTmcm8H9eYPshQ+yEt4Ys1KhCROaOIWKzKHbZMb8JCJGXZ05aqQBHPWHva0LPxW+ikeFxRYj/awGQ8jOX5zhA+GUGCR5ybn0SnKNdL6MO5U4ZseVuE3GAxt2UF6TCSkBNICctFjLFVt0fj7pGIUsUFOnDO8tDEcMhmrtSWLMigJh4l53nlMEmh3I4I9Hu8b8jeJEcUqVkayxRQwEu3nCf4PuLqGdUiQoRFMzEXkIQchT7O59ukuJP31ibLdg8zwh5PWW7EKgkptyemnf4jRREEZmmEljDwfoYr5bIiZiP7dFKESDC88lbFECjSjQJAGHuCC4YkaTjMskyQ9lxlRCDiC8KZRnd4OX0W2vqZm3D3rkBT1zChzHTdyfegJo55ifU7DYWLFvelUo9NgLOWoIIRnZKDtAiXWXzFZ7Rpi4lBqwBWkHiD7TrJkKa/LwOexzr7lnQadXi8p/Thb1GS+LWuZ8o0xJSp9MRcvao2+fY/5V3661DlVPF9CGFdgzluXUYeVzK4knAuQJTjmpIbPXdoCFVfTQD3k8JVxQiEhbGkXMUoojBRnLSZTZHPGFtjSrdxwDYmnjbxWPTCpdjT78vHISeVES3ijzJRxwKPo+mfFZTJyDfxwuCXRv/Fe5rktKwpA3oNE9cvojF1ceydzWzaXF9Qfd5AKrWKrlmjlZ5FrZVwwU1icqKfE/r43Uph32U026mT8f8uwz6GtHTRtITKsoTfNyYQGegq+gNLJ8r4PCSveRWxrGTiRYur+FOEZOFrh+paOflZr45JR37CkEHpzLzJyueckxeQnDPH0ZgGtNWsC4KymlEVELc8QLdchzqTjBawkpyegxrjlmm3bWT6MT1vLHafCJBMIQiKS8J3zUbjfhvTS0QzOc2+RmP9zDn5vH/iQLKFSlsLmmA+UpFg8X9RzgA53cx4xiJnLPIxaeCMa31Miv3QZP//LSJHbO66fuFR6PQuI1pE7gXyY73cFbRWn/pRZiw15gJiDCGn1HLKH5Yrj+syn8CfDPgfYsYieNr0P29ut0BDuPpy3hJ3vRmsfvy0EW4UQf4HFuOCezl0rtwAAAAASUVORK5CYII=',
              symbolOffset:[15,-30],
              symbolRotate:-5,
              data: [],//convertData(outdata),
              zlevel: 1,
            },
            {
              type: "effectScatter",
              coordinateSystem: "geo",
              rippleEffect: {
                brushType: "stroke",
              },
              showEffectOn: "render",
              itemStyle: {
                normal: {
                  color: {
                    type: "radial",
                    x: 0.5,
                    y: 0.5,
                    r: 0.5,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(5,80,151,0.2)",
                      },
                      {
                        offset: 0.8,
                        color: "rgba(5,80,151,0.8)",
                      },
                      {
                        offset: 1,
                        color: "rgba(0,108,255,0.7)",
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                },
              },
              label: {
                normal: {
                  show: true,
                  color: "#fff",
                  fontWeight: "bold",
                  position: "inside",
                  formatter: function (para) {
                    return "{cnNum|" + para.data.value[2] + "}";
                  },
                  rich: {
                    cnNum: {
                      fontSize: 13,
                      color: "#D4EEFF",
                    },
                  },
                },
              },
              symbol: "circle",
              symbolSize: function (val) {
                if (val[2] === 0) {
                  return 0;
                }
                var a = (maxSize4Pin - minSize4Pin) / (max - min);
                var b = maxSize4Pin - a * max;
                return a * val[2] + b * 1.2;
              },
              data: [],//convertData(outdata),
              zlevel: 1,
            },
          ],
        };

        this.myMapChart.setOption(option)
        window.addEventListener('resize',this.sizeFunOfMapChart)
      },

      setConsMonthChart(){
        var chart12 = this.$refs.consMonthSalesChart;
        this.myChart12 = echarts.getInstanceByDom(chart12);
        if(this.myChart12 === undefined){
          this.myChart12 = echarts.init(chart12);
        }else{
          this.myChart12.dispose()
          this.myChart12 = null;
          this.myChart12 = echarts.init(chart12);
        }

        var option = {
          toolbox: {
            show: true,
            feature: {
              mark: {
                show: true,
              },
              saveAsImage: {
                show: true,
                backgroundColor:'#143673'
              },
            },
          },
          tooltip: {
            orient: "vertical",
            trigger: "axis",
            axisPointer: {
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(0, 255, 233,0)",
                    },
                    {
                      offset: 0.5,
                      color: "rgba(255, 255, 255,1)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 255, 233,0)",
                    },
                  ],
                  global: false,
                },
              },
            },
          },
          grid: {
            top: "15%",
            left: "5%",
            right: "5%",
            bottom: "15%",
          },
          xAxis: [
            {
              type: "category",
              axisLine: {
                show: true,
              },
              splitArea: {
                color: "#f00",
                lineStyle: {
                  color: "#f00",
                },
              },
              axisLabel: {
                color: "#fff",
              },
              splitLine: {
                show: false,
              },
              boundaryGap: false,
              data: []
            },
          ],

          yAxis: [
            {
              type: "value",
              min: 0,
              // max: 140,
              splitNumber: 4,
              splitLine: {
                show: true,
                lineStyle: {
                  color: "rgba(255,255,255,0.1)",
                },
              },
              axisLine: {
                show: false,
              },
              axisLabel: {
                show: false,
                margin: 20,
                textStyle: {
                  color: "#d1e6eb",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          series: [
            {
              // name: "注册总量",
              type: "line",
              smooth: true, //是否平滑
              showAllSymbol: true,
              symbol: "circle",
              symbolSize: 15,
              lineStyle: {
                normal: {
                  color: "#00b3f4",
                  shadowColor: "rgba(0, 0, 0, .3)",
                  shadowBlur: 0,
                  shadowOffsetY: 5,
                  shadowOffsetX: 5,
                },
              },
              label: {
                show: true,
                position: "top",
                textStyle: {
                  color: "#00b3f4",
                },
              },
              itemStyle: {
                color: "#00b3f4",
                borderColor: "#fff",
                borderWidth: 3,
                shadowColor: "rgba(0, 0, 0, .3)",
                shadowBlur: 0,
                shadowOffsetY: 2,
                shadowOffsetX: 2,
              },
              tooltip: {
                show: false,
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: "rgba(0,179,244,0.3)",
                      },
                      {
                        offset: 1,
                        color: "rgba(0,179,244,0)",
                      },
                    ],
                    false
                  ),
                  shadowColor: "rgba(0,179,244, 0.9)",
                  shadowBlur: 20,
                },
              },
              data: []
            },
          ],
        };

        this.myChart12.setOption(option)
        window.addEventListener('resize',this.sizeFunOfMyChart12)
      },
      //手术部位占比
      setSurgeryPartChart(){
        var chart34 = this.$refs.surgeryPart;
        this.myChart34 = echarts.getInstanceByDom(chart34);
        if(this.myChart34 === undefined){
          this.myChart34 = echarts.init(chart34);
        }else{
          this.myChart34.dispose()
          this.myChart34 = null;
          this.myChart34 = echarts.init(chart34);
        }

        var option = {
          toolbox: {
            show: true,
            feature: {
              mark: {
                show: true,
              },
              magicType: {
                show: true,
                type: ["pie", "funnel"],
              },
              saveAsImage: {
                show: true,
                backgroundColor:'#143673'
              },
            },
          },
          calculable: true,
          tooltip: {
            trigger: "item",
            formatter:"{b}:{d}%"
          },
          title: {
            show: false,
          },
          calculable: true,
          legend: {
            show: true,
            icon: "circle",
            x: "center",
            y: "6%",
            data: [], //xData,
            textStyle: {
              color: "#fff",
            },
          },
          series: [
            {
              name: "手术部位",
              type: "pie",
              radius: [27,70],//[37, 155],27,70
              avoidLabelOverlap: false,
              startAngle: 0,
              center: ["50.1%", "54%"],
              roseType: "area",
              selectedMode: "single",
              label: {
                normal: {
                  show: true,
                  formatter: "{d}%",
                },
                emphasis: {
                  show: true,
                },
              },
              labelLine: {
                normal: {
                  show: true,
                  smooth: false,
                  length: 20,
                  length2: 10,
                },
                emphasis: {
                  show: true,
                },
              },
              data: [] //originalArray,
            },
          ],
        };

        this.myChart34.setOption(option);
        window.addEventListener('resize',this.sizeFunOfMyChart34)
      },
      //3 耗材类型占比
      setConsTypeChart(){
        var chart31 = this.$refs.consTypeChart;
        this.myChart31 = echarts.getInstanceByDom(chart31);
        if(this.myChart31 === undefined){
          this.myChart31 = echarts.init(chart31);
        }else{
          this.myChart31.dispose()
          this.myChart31 = null;
          this.myChart31 = echarts.init(chart31);
        }

        var option = {
          toolbox: {
            show: true,
            feature: {
              mark: {
                show: true,
              },
              saveAsImage: {
                show: true,
                backgroundColor:'#143673'
              },
            },
          },
          tooltip: {
            show: false,
          },
          legend: {
            show: false,
          },
          series: [],//seriesObj,
        };

        this.myChart31.setOption(option);
        window.addEventListener('resize',this.sizeFunOfMyChart31())
      },
      setConsYearChart(){
        var chart13 = this.$refs.consYearSalesChart;
        this.myChart13 = echarts.getInstanceByDom(chart13);
        if(this.myChart13 === undefined){
          this.myChart13 = echarts.init(chart13)
        }else{
          this.myChart13.dispose();
          this.myChart13 = null;
          this.myChart13 = echarts.init(chart13)
        }

        var option = {
          // backgroundColor: "rgb(20, 58, 110)",
          color: ["#3cefff"],
          tooltip: {},
          grid: {
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: [],//xData,
              axisTick: {
                alignWithLabel: true,
              },
              nameTextStyle: {
                color: "#82b0ec",
              },
              axisLine: {
                lineStyle: {
                  color: "#82b0ec",
                },
              },
              axisLabel: {
                textStyle: {
                  color: "#82b0ec",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              axisLabel: {
                textStyle: {
                  color: "#82b0ec",
                },
                formatter: "{value}",
              },
              splitLine: {
                lineStyle: {
                  color: "#0c2c5a",
                },
              },
              axisLine: {
                show: false,
              },
            },
          ],
          series: [
            {
              name: "",
              type: "pictorialBar",
              symbolSize: [20, 10],
              symbolOffset: [0, -5],
              symbolPosition: "end",
              z: 12,
              label: {
                normal: {
                  show: true,
                  position: "top",
                  formatter: "{c}",
                },
              },
              data: [] //yData,
            },
            {
              name: "",
              type: "pictorialBar",
              symbolSize: [20, 10],
              symbolOffset: [0, 5],
              z: 12,
              data: [], //yData,
            },
            {
              type: "bar",
              itemStyle: {
                normal: {
                  opacity: 0.7,
                },
              },
              barWidth: "20",
              data: [], //yData,
              markLine: {
                silent: true,
                symbol: "none",
                label: {
                  position: "middle",
                  formatter: "{b}",
                },
                data: [
                  {
                    name: "目标值",
                    yAxis: 2, //可根据实际情况设置
                    lineStyle: {
                      color: "#ffc832",
                    },
                    label: {
                      position: "end",
                      formatter: "{b}\n {c}",
                    },
                  },
                ],
              },
            },
            {
              type: "effectScatter",
              silent: true,
              tooltip: {
                show: false,
              },
              zlevel: 3,
              symbolSize: 10,
              showEffectOn: "render",
              rippleEffect: {
                brushType: "stroke",
                color: "#3cefff",
                scale: 5,
              },
              itemStyle: {
                color: "#3cefff",
              },
              hoverAnimation: true,
              data: [], //xZeroData,
            },
          ],
        };

        this.myChart13.setOption(option)
        window.addEventListener('resize',this.sizeFunOfMyChart13)
      },
      // 耗材总消耗
      setConsSumChart(){
        var chart32 = this.$refs.consSalesumChart;
        this.myChart32 = echarts.getInstanceByDom(chart32);
        if(this.myChart32 === undefined){
          this.myChart32 = echarts.init(chart32)
        }else{
          this.myChart32.dispose();
          this.myChart32 = null;
          this.myChart32 = echarts.init(chart32)
        }

        var option = {
          tooltip: {},
          grid: {
            top: "8%",
            left: "1%",
            right: "1%",
            bottom: "8%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: true,
              axisLine: {
                //坐标轴轴线相关设置。数学上的x轴
                show: true,
                lineStyle: {
                  color: "rgba(0,0,0,0)",
                },
              },
              axisLabel: {
                //坐标轴刻度标签的相关设置
                textStyle: {
                  color: "#d1e6eb",
                  margin: 15,
                  fontSize:8,
                },
              },
              axisTick: {
                show: false,
              },
              data:[],//xArr
            },
          ],
          yAxis: [
            {
              type: "value",
              min: 0,
              // max: 140,
              splitNumber: 7,
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#0a3256",
                },
              },
              axisLine: {
                show: false,
              },
              axisLabel: {
                margin: 20,
                textStyle: {
                  color: "#d1e6eb",
                  fontSize:8,
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          series: [
            {
              name: "消耗总量",
              type: "line",
              // smooth: true, //是否平滑曲线显示
              			// symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
              showAllSymbol: false,
              symbol: "emptyCircle",
              symbolSize: 0,
              lineStyle: {
                normal: {
                  color: "#00EBF4", // 线条颜色
                },
                borderColor: "#f0f",
              },
              label: {
                show: false,
                position: "top",
                textStyle: {
                  color: "#fff",
                },
              },
              itemStyle: {
                normal: {
                  color: "#00EBF4",
                },
              },
              tooltip: {
                show: false,
              },
              areaStyle: {
                //区域填充样式
                normal: {
                  //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: "#00EBF4",
                      },
                      {
                        offset: 1,
                        color: "rgba(0,0,0, 0)",
                      },
                    ],
                    false
                  ),
                  shadowColor: "rgba(53,142,215, 0.9)", //阴影颜色
                  shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                },
              },
              data: [],//yArr
            }
          ],
        };

        this.myChart32.setOption(option)
        window.addEventListener('resize',this.sizeFunOfMyChart32)
      },
      setEquipYearChart(){
        var chart14 = this.$refs.equipYearSalesChart;
        this.myChart14 = echarts.getInstanceByDom(chart14);
        if(this.myChart14 === undefined){
          this.myChart14 = echarts.init(chart14)
        }else{
          this.myChart14.dispose();
          this.myChart14 = null;
          this.myChart14 = echarts.init(chart14)
        }

        // Generate data
        // var category = this.equipYearData.year;

        // option
        var option = {
          title: {
            text: "",
            x: "center",
            y: 0,
            textStyle: {
              color: "#B4B4B4",
              fontSize: 16,
              fontWeight: "normal",
            },
          },
          // backgroundColor: "#0d235e",
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.1)",
            axisPointer: {
              type: "shadow",
              label: {
                show: true,
                backgroundColor: "#7B7DDC",
              },
            },
          },
          legend: {
            textStyle: {
              color: "#B4B4B4",
            },
            top: "7%",
          },
          grid: {
            x: "12%",
            width: "82%",
            y: "12%",
          },
          xAxis: {
            data: [],//category,
            axisLine: {
              lineStyle: {
                color: "#B4B4B4",
              },
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: [

            {
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#B4B4B4",
                },
              },
              axisLabel: {
                formatter: "{value} ",
              },
            },
          ],

          series: [
            {

              type: "bar",
              barWidth: 10,
              itemStyle: {
                normal: {
                  barBorderRadius: 5,
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#956FD4" },
                    { offset: 1, color: "#3EACE5" },
                  ]),
                },
              },
              data: [],//this.equipYearData.value,
            },
          ],
        };

        this.myChart14.setOption(option);
        window.addEventListener('resize',this.sizeFunOfMyChart14)
      },
      //5 耗材消耗top10
      setHospitalConsChart(){
        var chart21 = this.$refs.tableConsSales;
        this.myChart21 = echarts.getInstanceByDom(chart21);
        if(this.myChart21 === undefined){
          this.myChart21 = echarts.init(chart21)
        }else{
          this.myChart21.dispose();
          this.myChart21 = null;
          this.myChart21 = echarts.init(chart21)
        }

        var option = {
          toolbox: {
            show: true,
            feature: {
              mark: {
                show: true,
              },
              saveAsImage: {
                show: true,
                backgroundColor:'#143673'
              },
            },
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
            formatter: function (objs, index) {
              let obj = objs[0];
            return `${obj.name}<br/>${obj.marker}${obj.seriesName} : ${obj.value} <br/>${obj.marker}占比 : ${obj.data.percent}%`;
            },
          },
          grid: {
            top:"1%",
            left: "2%",
            right: "2%",
            containLabel: true,
          },
          xAxis: {
            type: "value",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
          yAxis: {
            type: "category",
            boundaryGap: true,
            inverse: true, //反向
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              margin: 12, //左右间隔
              formatter: function (value, index) {
                //文字换行
                var newParamsName = "";
                var paramsNameNumber = value.length;
                var provideNumber = 6;// 一行显示几个字 然后就超过字数就会自动换行
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = "";
                    var start = p * provideNumber;
                    var end = start + provideNumber;
                    if (p === rowNumber-1){
                      tempStr = value.substring(start, paramsNameNumber);
                    } else {
                      tempStr = value.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr;
                  }
                } else {
                  newParamsName = value;
                }

                var ind = index + 1;
                if (ind == 1) {
                    return "{a|" + newParamsName + "}";
                } else if (ind == 2) {
                  return "{b|" + newParamsName + "}";
                } else if (ind == 3) {
                  return "{c|" + newParamsName + "}";
                } else {
                  return "{d|" + newParamsName + "}";
                }
              },
              rich: {
                a: {
                  align:'left',
                  color: this.colors21[0],
                },
                b: {
                  align:'left',
                  color: this.colors21[1],
                },
                c: {
                  align:'left',
                  color: this.colors21[2],
                },
                d: {
                  align:'left',
                  color: this.colors21[3],
                },
              },
            },
            data: [],//provRank,
          },
          series: [
            {
              name: "消耗量",
              barMaxWidth: "40%",
              type: "bar",
              label: {
                normal: {
                  show: true,
                  position: "insideLeft",
                  formatter: "{c}",
                  textStyle: {
                    color: "#fff",
                  },
                },
              },
              data:[],//array1,
            },
          ],
        };

        this.myChart21.setOption(option);
        window.addEventListener('resize',this.sizeFunOfMyChart21)
      },
      handleDataOfHospitalCons(){
        var colors = this.colors21;

        var dfColor = {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 1,
              color: "#0489f0", // 0% 处的颜色
            },
            {
              offset: 0,
              color: "#28d9e8", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        };

        var array1 = this.hospitalData;
        var provRank = []
        for(var index=0;index<array1.length;index++){
          var element = array1[index];
          provRank.push(element.name)
          if(index<3){
            element.itemStyle = {color:colors[index]}
          }else{
            element.itemStyle = {color:dfColor}
          }
        }

        this.myChart21.setOption({
          yAxis: {data: provRank},
          series:[{data:array1}]
        });
      },
      getConsMonthDistribution(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/ship/consumable/month';
        const params = {start:this.consMonthValue.getFullYear()+'-01',end:this.consMonthValue.getFullYear()+'-12'}

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:params
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.value){
                this.consMonthData.value = obj.data.value;
              }
              // this.setConsMonthChart()

              this.myChart12.setOption({
                xAxis:[{data:this.months}],
                series:[{data:this.consMonthData.value}]
              })

            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{

          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getConsSumDistribution(){
        var date = new Date()
        var startTime = ''
        var endTime = date.getFullYear() + '-' + this.judgeNumber((date.getMonth()+1))
        var chazhi = date.getMonth()+1 - 11
        if(chazhi <= 0){
          startTime = (date.getFullYear()-1) + '-' + this.judgeNumber((12+chazhi))
        }else{
          startTime = date.getFullYear() + '-01'
        }
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/ship/consumable/month-total';
        const params = {start:startTime,end:endTime}
        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:params
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.value){
                this.consYearData.value = obj.data.value;
              }
              if(obj.data.year){
                this.consYearData.year = obj.data.year
              }
              if(obj.data.month){
                this.consYearData.month = obj.data.month
              }
              // this.setConsSumChart()
              this.handleDataOfConsSum()


            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{

          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      handleDataOfConsSum(){
        var data = this.consYearData;
        var xArr = [];
        for(var i=0;i<data.year.length;i++){
          xArr.push(data.year[i]+'/'+this.judgeNumber(data.month[i]));
        }
        var yArr = data.value;

        this.myChart32.setOption({
        	xAxis:[{data:xArr}],
        	series:[{data: yArr}]
        })
      },

      judgeNumber(value){
        if(value<10){
          return '0'+value;
        }
        return value;
      },
      getConsYearDistribution(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/ship/consumable/year';
        const params = {start:this.consYearStart.getFullYear(),end:this.consYearEnd.getFullYear()}
        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:params
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.value){
                this.consYearData.value = obj.data.value;
              }
              if(obj.data.year){
                this.consYearData.year = obj.data.year
              }
              // this.setConsYearChart()

              this.handleDataOfConsYear()

            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{

          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      handleDataOfConsYear(){
        var xData = this.consYearData.year;
        var yData = this.consYearData.value;
        var xZeroData = []
        for(var index=0;index<xData.length;index++){
          xZeroData.push(0);
        }

        this.myChart13.setOption({
        	xAxis:[{data:xData}],
        	series:[{data:yData},
                  {data:yData},
                  {data:yData},
                  {data: xZeroData},
                ]
        });
      },

      // 1设备状态的统计 -左一
      getEquipStatus(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/equipment-status';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data){
                this.equipOnAmount = obj.data.onAmount
                this.equipOffAmount = obj.data.offAmount
                this.equipFaultedAmount = obj.data.faultedAmount
                this.equipSurgeryAmount = obj.data.surgeryAmount
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
          if(err.response.status == 401){
            this.$router.replace('/login');
          }
        })
      },
      // 2手术部位
      getSurgeryPartDistribution(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/surgery-part';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.parts){
                this.partData = obj.data.parts;
                // this.setSurgeryPartChart()
                this.handleDataOfSurgeryPart()
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{

          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      handleDataOfSurgeryPart(){
        var originalArray = this.partData;
        var colors = ['#f845f1','#ad46f3','#5045f6','#4777f5','#44aff0']
        var xData = []
        for(var index=0;index<originalArray.length;index++){
          var element = originalArray[index]
          xData.push(element.name)
          var ccc = {'color':colors[index]}
          element.itemStyle = {'normal':ccc};
          element.label = {'color':colors[index]}
        }

        this.myChart34.setOption({
          legend:{data:xData},
          series:[{data: originalArray}]
        })
      },

      // 5各医院耗材消耗统计排名
      getHospitalDistribution(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/consumable-use/hospital/year';

        var params = {year:this.topValue.getFullYear()}

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:params
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.hospitals){
                this.hospitalData = obj.data.hospitals;
                this.hospitalData = this.hospitalData.slice(0,10);
                // this.setHospitalConsChart()

                this.handleDataOfHospitalCons()
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      //
      getEquipSumDistribution(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/ship/equipment/year';

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:{start:this.equipYearStart.getFullYear(),end:this.equipYearEnd.getFullYear()}
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.year){
                this.equipYearData.year = obj.data.year;
              }
              if(obj.data.value){
                this.equipYearData.value = obj.data.value;
              }
              // this.setEquipYearChart();

              this.myChart14.setOption({
              	xAxis:{data:this.equipYearData.year},
              	series:[{data: this.equipYearData.value}]
              })

            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })

      },
      // 3耗材类型统计
      getConsTypeDistribution(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/consumable-type';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.consumableType){
                this.consTypeData = obj.data.consumableType;
                // this.setConsTypeChart()

                this.handleDataOfConsType()
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })

      },
      handleDataOfConsType(){
        var scaleData = this.consTypeData;
        var data = [];
        for (var i = 0; i < scaleData.length; i++) {
          data.push({
            value: scaleData[i].value,
            name: scaleData[i].name,
            itemStyle: {
              normal: {
                borderWidth: 5,
                shadowBlur: 10,//30
                borderColor: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
                                    {
                                      offset: 0,
                                      color: "#7777eb",
                                    },
                                    {
                                      offset: 1,
                                      color: "#70ffac",
                                    },
                                  ]),
                                  shadowColor: "rgba(142, 152, 241, 0.6)",
                                },
            },
          },
          {
            value: 4,
            name: "",
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                color: "rgba(0, 0, 0, 0)",
                borderColor: "rgba(0, 0, 0, 0)",
                borderWidth: 0,
              },
            },
          });
        }

        var seriesObj = [
          {
            name: "",
            type: "pie",
            clockWise: false,
            radius:[65,70],
            hoverAnimation: false,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "outside",
                  color: "#ddd",
                  formatter: function (params) {
                    var percent = 0;
                    var total = 0;
                    for (var i = 0; i < scaleData.length; i++) {
                      total += scaleData[i].value;
                    }
                    percent = ((params.value / total) * 100).toFixed(0);
                    if (params.name !== "") {
                      return params.name + '\n{white|占比:' + percent + '%}';
                    } else {
                      return "";
                    }
                  },
                  rich:  {
                    white: {
                      color: "#ddd",
                      align: "center",padding: [5, 0],
                    },
                  },
                },
                labelLine: {
                  show: false,
                },
              },
            },
            data: data,
          }];

        this.myChart31.setOption({
        	series: seriesObj,
        });
      },

      // 6各省设备医院统计
      getDistribution(){
        this.loading = true
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/province';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.provinces){
                // 获取数据
                this.mapDistributionData = obj.data.provinces;
                areaConversionUtil.codeToName(this.mapDistributionData);

                // this.setMap()

                this.handleDataOfMap();
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      handleDataOfMap(){
        var originalData = this.mapDistributionData;
        var outdata = [];

        for (var i = 0; i < originalData.length; i++) {
          var element = originalData[i];
          var name = element.provinceName
          if(name == '新疆维吾尔自治区'){name = '新疆'}
          else if(name == '内蒙古自治区'){name = '内蒙古'}
          else if(name == '宁夏回族自治区'){name = '宁夏'}
          else if(name == '广西壮族自治区'){name = '广西'}
          else if(name == '西藏自治区'){name = '西藏'}
          else if(name == '澳门特别行政区'){name = '澳门'}
          else if(name == '香港特别行政区'){name = '香港'}
          else {name = name.substring(0,name.length-1)}
          outdata.push({
            name:name,
            value:element.equipmentAmount,
            hospitalAmount:element.hospitalAmount,
            consAmount:element.consumableUsedAmount,
            status:{
              surgeryAmount:element.status.surgeryAmount,
              onAmount:element.status.onAmount,
              offAmount:element.status.offAmount,
              faultedAmount:element.status.faultedAmount,
            }
          })
        }

        var geoCoordMap = {};
        /*获取地图数据*/
        var mapFeatures = echarts.getMap("china").geoJson.features;

        mapFeatures.forEach(function (v) {
          // console.info(v);
          // 地区名称
          var name = v.properties.name;
          // 地区经纬度
          geoCoordMap[name] = v.properties.cp;
        });
        var convertData = function (outdata) {
          var res = [];
          for (var i = 0; i < outdata.length; i++) {
            var geoCoord = geoCoordMap[outdata[i].name];
            if (geoCoord) {
              res.push({
                name: outdata[i].name,
                value: geoCoord.concat(outdata[i].value),
              });
            }
          }
          return res;
        };

        this.myMapChart.setOption({
          series:[
            {data: outdata},
            {data: convertData(outdata)},
            {data: convertData(outdata)}]
        });
      },
      changeConsMonthYear(value){
        this.getConsMonthDistribution()
      },
      changeConsTopYear(value){
        this.getHospitalDistribution()
      },
      changeStartYearOfCons(value){
        //开始年份
        var startYear = value.getFullYear()
        var endYear = this.consYearEnd.getFullYear()
        if(startYear<=endYear){
          this.getConsYearDistribution()
        }else{
          this.consYearStart = this.consYearEnd;
          // this.$message({
          //   type:'warning',
          //   message:'时间范围无效'
          // })
          this.getConsYearDistribution()

        }
      },
      changeEndYearOfCons(value){
        //开始年份
        var startYear = this.consYearStart.getFullYear()
        var endYear = value.getFullYear()
        if(startYear<=endYear){
          this.getConsYearDistribution()
        }else{
          this.consYearEnd = this.consYearStart;
          // this.$message({
          //   type:'warning',
          //   message:'时间范围无效'
          // })
          this.getConsYearDistribution()
        }
      },
      changeStartYearOfEquip(value){
        //开始年份
        var startYear = value.getFullYear()
        var endYear = this.equipYearEnd.getFullYear()
        if(startYear<=endYear){
          this.getEquipSumDistribution()
        }else{
          this.equipYearStart = this.equipYearEnd;
          // this.$message({
          //   type:'warning',
          //   message:'时间范围无效'
          // })
          this.getEquipSumDistribution()
        }
      },
      changeEndYearOfEquip(value){
        //开始年份
        var startYear = this.equipYearStart.getFullYear()
        var endYear = value.getFullYear()
        if(startYear<=endYear){
          this.getEquipSumDistribution()
        }else{
          this.equipYearEnd = this.equipYearStart;
          // this.$message({
          //   type:'warning',
          //   message:'时间范围无效'
          // })
          this.getEquipSumDistribution()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.container{
  margin-top: $header-height;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .content-right{
    width: 640px;
    height: 100%;
    display: flex;
    flex-direction: column;
    // justify-content: space-evenly;

    .part-title{
        margin-left: 10px;
        margin-top: 10px;
        font-size: 18px;
        font-weight: bold;
        color: #FEFEFE;
    }

    // 耗材数据分析
    .data-cons{
      float: left;
      display: flex;
      flex-direction: row;
      width: 640px;

      // 1.耗材消耗top10
      .table-hospital-cons{
        width: 50%;
        border: 1px #3963bc solid;
        border-radius: 2px;

        .table-hospital-cons-chart{
          width: 100%;
          // height: 639px;
          // height: 670px;
          height: 694px;
        }
      }

      // 2.耗材类型
      .data-cons-analysis{
        width: 50%;
        margin-left: 10px;

        .cons-type{
          width: 100%;
          border: 1px #3963bc solid;
          border-radius: 2px;

          .cons-type-chart{
            width: 100%;
            height: 326px;
          }
        }

        // 3.总耗材消耗
        .cons-sales{
          width: 100%;
          border: 1px #3963bc solid;
          border-radius: 2px;
          margin-top: 10px;

          .cons-sales-chart{
            width: 100%;
            height: 326px;
          }
        }
      }
    }

    // 设备数据分析
    .data-equip{
      display: flex;
      flex-direction: row;
      width: 640px;
      margin-top: 10px;

      // 设备分布
      .table-equip-sales{
        width: 49%;
        border: 1px #3963bc solid;
        border-radius: 2px;

        .table-equip-sales-chart{
          width: 100%;
          // height: 648px;
          height: 630px;
        }
      }

      // 1.设备状态
      .data-equip-analysis{
        width: 50%;
        margin-left: 10px;

        .equip-status{
          width: 100%;
          border: 1px #3963bc solid;
          border-radius: 2px;

          .equip-status-chart{
            width: 100%;
            height: 290px;
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;

            .part-one{
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              width: 49%;

              .part-one-title{
                font-size: 12px;
                color: #aaa;
              }

              .part-one-detail{
                font-size: 30px;
                font-weight: bold;
                color: #FEFEFE;
              }
            }
          }
        }

        // 2.手术部位统计
        .surgery-part{
          width: 100%;
          border: 1px #3963bc solid;
          border-radius: 2px;
          margin-top: 10px;

          .surgery-part-chart{
            width: 100%;
            height: 290px;
          }
        }
      }
    }
  }

  // 地图
  .content-center{
    width: calc(100% - 640px);
    height: 100%;
    // margin-left: 10px;
    margin-right: 10px;

    .content-map{
      width: 100%;
      height: calc(100% - 320px);
      float: left;

      .map-back{
        height: 50%;
        // min-height: 720px;
        border: 1px #3963bc solid;
        border-radius: 2px;

        .echart-map{
          width: 100%;
          height: 100%;
          border-radius: 8px;
          width: 840px;
          // height: 800px;
          height: 400px;
        }
      }


      .bottom-line{
        width: 100%;
        border: 1px #3963bc solid;
        border-radius: 2px;
        margin-top: 10px;

        .part-title{
          margin-left: 5px;
          padding-top: 15px;
          margin-right: 3px;
          border-radius: 4px 4px 0 0;

          p{
            margin-left: 10px;
            margin-top: 0px;
            font-size: 18px;

            font-weight: bold;
            color: #FEFEFE;
          }
        }

        .bottom-line-chart{
          width: 100%;
          height: 276px;
        }
      }
    }
  }

  .border11 text.dv-border-box-13-title[fill]{
    font-size: 30px;
    font-family: 'MicrosoftYaHei-Bold';
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/index.vue